import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const ConfirmDialog = ({ open, title, content, onCancel, onConfirm }) => (
  <Dialog open={open} onClose={onCancel}>
    <DialogTitle color="error">{title}</DialogTitle>
    <DialogContent>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        py={2}
      >
        <WarningAmberIcon color="warning" sx={{ fontSize: 56, mb: 1 }} />
        <DialogContentText variant="h6">{content}</DialogContentText>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Cancel</Button>
      <Button
        variant="contained"
        color="error"
        startIcon={<DeleteForeverIcon />}
        onClick={onConfirm}
      >
        Delete Permanently
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
